import { Link } from "react-router-dom";
import PageBanner from "../../PageBanner";
import SocialMediaSidebar from "../../SocialMediaSidebar";
import SectionHeader from "../../SectionHeader";
import ScrollToTopButton from "../../ScrollToTopButton";
import SectionHeaderNoPDF from "../../SectionHeaderNoPDF";

const OfferingSmartSegregation = () => {
  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <PageBanner
        title="Smart Segregation"
        breadcrumb={[
          { label: "Home", href: "/" },
          { label: "Offerings" },
        ]}
      />
      <div className="max-w-6xl mx-auto p-4">
        <SectionHeaderNoPDF
          title="Smart Segregation @ AJEEVI"
          shareUrl="https://swmecom.ajeevi.in/smart-segregation"
        />
      </div>
      <div>
        <ScrollToTopButton />
      </div>

      {/* Page content */}
      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800 text-justify">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Summary Section */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              Summary
            </h4>
            <p className="text-black mb-4 text-lg">
              Smart segregation systems revolutionize waste management by enabling accurate sorting at the source through IoT-enabled bins, AI-powered recognition, and user feedback mechanisms. This technology significantly improves recycling rates and reduces contamination in waste streams.
            </p>
            <p className="text-black text-lg">
              Municipalities and businesses implementing smart segregation solutions achieve higher quality recyclables, lower processing costs, and make substantial progress toward zero-waste goals while educating communities about proper waste disposal.
            </p>
          </div>

          {/* Introduction Section */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              Introduction
            </h4>
            <p className="text-black mb-4 text-lg">
              Effective waste management begins with proper segregation at the source. Smart segregation technologies empower residents and businesses to correctly separate waste through intelligent systems that guide, monitor, and incentivize proper sorting behavior.
            </p>
            <p className="text-black text-lg">
              By combining sensor technology, machine learning, and user-friendly interfaces, these solutions dramatically improve the quality of segregated waste while providing valuable data for waste management optimization and policy making.
            </p>
          </div>

          {/* Key Features Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-4 text-black">
              Key Features of Smart Segregation Systems:
            </h5>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black">
              <li>
                <strong>Automated Waste Recognition:</strong> AI-powered cameras and sensors identify waste types and guide proper disposal
              </li>
              <li>
                <strong>Interactive Feedback:</strong> Visual and auditory signals confirm correct segregation or provide correction guidance
              </li>
              <li>
                <strong>Contamination Alerts:</strong> Immediate notifications when non-conforming waste is detected in specific streams
              </li>
              <li>
                <strong>User Authentication:</strong> Optional identification systems to track individual or household participation
              </li>
              <li>
                <strong>Data Analytics:</strong> Comprehensive reporting on segregation accuracy and waste composition trends
              </li>
              <li>
                <strong>Reward Systems:</strong> Integration with incentive programs to encourage continued proper segregation
              </li>
            </ul>
          </div>

          {/* Benefits Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-3 text-black">
              Operational Benefits
            </h5>
            <p className="text-black text-lg mb-4">
              Implementing smart segregation delivers significant advantages throughout the waste management chain:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>50-80% reduction in recycling stream contamination</li>
              <li>30-60% increase in recoverable recyclable materials</li>
              <li>Lower processing costs due to cleaner input streams</li>
              <li>Reduced landfill fees through better diversion rates</li>
              <li>Valuable data for waste composition analysis and planning</li>
              <li>Continuous community education through interactive systems</li>
            </ul>
          </div>

          {/* Implementation Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-3 text-black">
              Implementation Considerations
            </h5>
            <p className="text-black text-lg mb-4">
              Successful smart segregation deployment requires strategic planning:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Selection of appropriate technology for the target environment (residential, commercial, public spaces)</li>
              <li>Clear communication of segregation categories and guidelines</li>
              <li>Integration with existing collection infrastructure</li>
              <li>Community engagement and education programs</li>
              <li>Gradual rollout with pilot testing before full deployment</li>
              <li>Ongoing performance monitoring and system adjustments</li>
            </ul>
          </div>

          {/* Ajeevi's Contribution Section */}
          <div>
            <h5 className="text-xl font-semibold mb-3 text-black">
              Ajeevi's Smart Segregation Solutions
            </h5>
            <p className="text-black mb-4 text-lg">
              Ajeevi offers comprehensive smart segregation systems tailored to various needs:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>
                <strong>Smart Bin Systems:</strong> IoT-enabled bins with waste recognition and user guidance
              </li>
              <li>
                <strong>Mobile Waste Identification:</strong> AI-powered app that identifies waste types via smartphone camera
              </li>
              <li>
                <strong>Community Segregation Stations:</strong> Centralized smart sorting points with educational displays
              </li>
              <li>
                <strong>Waste Analytics Platform:</strong> Real-time monitoring of segregation performance and waste streams
              </li>
              <li>
                <strong>Integration with Collection Systems:</strong> Seamless connection between segregation and collection operations
              </li>
            </ul>
            <p className="text-black text-lg">
              Discover how Ajeevi's smart segregation solutions can transform your waste management system. Visit{" "}
              <a
                href="http://www.ajeevi.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#00D084] hover:underline"
              >
                www.ajeevi.com
              </a>{" "}
              for more information.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default OfferingSmartSegregation;